import { createContext } from 'react';

export const SUMMARY_CONTEXT = createContext();
export const SummaryContextProvider = SUMMARY_CONTEXT.Provider;

export default { SUMMARY_CONTEXT, SummaryContextProvider };
